import { MissionsComponent } from './missions.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';

import * as moment from 'moment';

import { SharedModule } from 'app/shared/shared.module';
import { MissionsListComponent } from '../missions/missions-list/missions-list.component';



// export function momentAdapterFactory() {
//     return adapterFactory(moment);
// }

@NgModule({
    declarations: [
        MissionsComponent,
        MissionsListComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MomentModule
    ],
    providers: [
        // {
        //   provide: MOMENT,
        //   useValue: moment
        // }
    ],
    exports: [

    ]
})
export class MissionsModule { }
